import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChecklistComponent } from './checklist.component';
import { ChecklistRoutingModule } from './checklist-routing.module';
import { AddChecklistComponent } from './add-checklist/add-checklist.component';
import { ChecklistProductServicesComponent } from './checklist-product-services/checklist-product-services.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { SharedModule } from 'src/app/shared/shared.module';
import { PopupModule } from '@progress/kendo-angular-popup';



@NgModule({
  declarations: [ChecklistComponent, AddChecklistComponent, ChecklistProductServicesComponent],
  imports: [
    CommonModule,
    ChecklistRoutingModule,
    GridModule,
    DropDownsModule,
    SharedModule,
    PopupModule,
    FormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    ReactiveFormsModule
  ]
})
export class ChecklistModule { }
